module.exports = __webpack_public_path__ + "6844b63bc9e2b53b5a62f6dcc77e1317.jpg";